<template>
    <div class="sign-up-wrap">
        <!--Patient SignUp-->
        <v-dialog
                v-model="show"
                fullscreen
                scrollable
                transition="dialog-bottom-transition"
        >

            <v-card class="sign-up-card">

              <v-card-title class="primary white--text">
                <v-btn dark icon @click="show=false">
                  <v-icon>close</v-icon>
                </v-btn>
                Crear Cuenta
                <v-spacer></v-spacer>

              </v-card-title>

                <div class="loading-container">
                    <v-progress-linear
                            v-show="loadingSignUp"
                            color="black"
                            height="2"
                            :indeterminate="true"
                            class="ma-0"
                    ></v-progress-linear>
                </div>

                <v-sheet class="mt-4" color="transparent darken-3 pa-3">
                    <v-layout justify-center>
                        <v-flex sm12 md10 xl9 mt-4>
                            <sign-up-stepper color="accent " v-on:close="show=false"></sign-up-stepper>
                        </v-flex>
                    </v-layout>
                </v-sheet>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>

    import { mapMutations } from 'vuex'
    import {ApiUtils} from '@/utils/ApiUtils'

    import SignUpStepper from './SignUpStepper.vue'

    export default{
        name: 'ServiceProviderSignUp',
        props: ['onSignUpSuccess', 'onCancel', 'model'],
        components: {SignUpStepper},
        beforeDestroy(){
          this.blurWrapper(false)
        },
        data(){
            return {
                loadingSignUp: false,
                valid: false,
                show: this.model || false,
                disabled: false
            }
        },
        watch:{
            model(newValue){
                this.show = newValue
            },
            show(newValue){
                this.$emit('change', newValue)
            }
        },
        computed: {

        },
        methods: {
            ...mapMutations([
                'showSnackBar',
                'blurWrapper',
            ]),
            cancel(){
                if(typeof this.onCancel == 'function'){
                    this.show = false
                    this.onCancel()
                }
            },
            async signUp(){

                var vm = this
                let user = {
                    first_name: vm.firstName,
                    last_names: vm.lastName1 + ' ' + vm.lastName2,
                    dni: vm.patientDNI,
                    gender: vm.gender,
                    phone: vm.phone
                }

                if(vm.insuranceCompany){
                    user.insurance_company_id = vm.insuranceCompany.id
                }

                if(vm.email){
                    user.email = vm.email
                }

                const response = await vm.submitSignUp(user)

                if(!response.ok){
                    vm.showSnackBar('Ocurrió un error registrando al paciente')
                    return
                }

                vm.show = false

                if(typeof vm.onSignUpSuccess == 'function'){
                    const json = await response.json()
                    vm.onSignUpSuccess(json.result.user)
                }
            },
            async submitSignUp(user = {}){

                let endpoint = 'provider'

                var vm = this
                vm.loadingSignUp = true
                const response = await ApiUtils.makePost('signup/' + endpoint, user)
                vm.loadingSignUp = false

                return response

            }
        }
    }
</script>

<style scoped>
    .sign-up-wrap{}

    .sign-up-card{
        position: absolute;
    }

    .loading-container{
        padding: 0;
        height: 2px;
        width: 100%;
    }
</style>
